/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LaborCostDto } from '../../models/labor-cost-dto';

export interface GetLaborCost$Params {
  id: string;
}

export function getLaborCost(http: HttpClient, rootUrl: string, params: GetLaborCost$Params, context?: HttpContext): Observable<StrictHttpResponse<LaborCostDto>> {
  const rb = new RequestBuilder(rootUrl, getLaborCost.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LaborCostDto>;
    })
  );
}

getLaborCost.PATH = '/v0/laborCosts/{id}';
